import { render, staticRenderFns } from "./housingInfo.vue?vue&type=template&id=3e7d90e6&scoped=true"
import script from "./housingInfo.vue?vue&type=script&lang=js"
export * from "./housingInfo.vue?vue&type=script&lang=js"
import style0 from "./housingInfo.vue?vue&type=style&index=0&id=3e7d90e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d90e6",
  null
  
)

export default component.exports